export const CloseButtonStyles = {
	baseStyle: {
		_focus: {
			boxShadow: 'none',
		},
	},
	sizes: {},
	variants: {},
};
